<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">总账</span>
    </div>
    <div class="margin-right-left margin-top">
      <account-period-selector
          @confirm="handleConfirm"
          @date-change="handleDateChange"
          :current-subject="subject"
          :subject-list="subjectList"
      />
      <div class="float-right" style="display:flex;gap:12px;align-items:center;">
        <Button @click="exportExcel">导出</Button>
        <Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
      </div>
    </div>
    <div class="h-panel-body margin" :space-x="10" style="overflow-x: auto;padding: 0;">
      <Loading text="总账数据加载中..." :loading="loading"></Loading>

      <!-- 非数量金额表格：绝对定位方案，彻底解决对齐 -->
      <div v-if="!showNumPrice" class="table-container">
        <div class="table-wrap">
          <table class="summary table-header">
            <thead>
            <tr class="header bg-primary-color white-color">
              <td width="100">科目编码</td>
              <td width="200">科目名称</td>
              <td width="100">期间</td>
              <td width="150">摘要</td>
              <td width="120">借方金额</td>
              <td width="120">贷方金额</td>
              <td width="80">方向</td>
              <td width="120">余额</td>
            </tr>
            </thead>
          </table>
          <div class="table-body">
            <table class="summary table-content">
              <tbody>
              <template v-for="item in datalist">
                <tr class="bg-gray3-color" :key="`item-${item.id}`">
                  <td colspan="8">
                      <span @click="toggleSummary(item)" class="text-hover">
                        <i class="fa fa-caret-down" :class="{'fa-caret-right':item._expand}"></i>
                        <span class="primary-color font-bold"> {{item.name}}</span>
                      </span>
                  </td>
                </tr>
                <template v-if="!item._expand" v-for="s in item.subjectSummary">
                  <tr class="summary-row" >
                    <td width="100">{{s.code}}</td>
                    <td width="200">{{s.subjectFullName}}</td>
                    <td width="100">{{s.voucherDate|fqFormat}}</td>
                    <td width="150">{{s.summary}}</td>
                    <td width="120" align="right">{{s.debitAmount}}</td>
                    <td width="120" align="right">{{s.creditAmount}}</td>
                    <td width="80" align="center">{{s.balanceDirection}}</td>
                    <td width="120" align="right">{{s.balance}}</td>
                  </tr>
                </template>
              </template>
              <tr v-if="!datalist.length">
                <td colspan="8" class="text-center padding">暂无数据</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 数量金额表格 -->
      <!--      <div v-else class="table-container">
              <div class="table-wrap" style="width: 1780px;">
                <table class="cus-table table-header">
                  <thead class="header">
                  <tr>
                    <td rowspan="2" width="100">科目编码</td>
                    <td rowspan="2" width="100">科目名称</td>
                    <td rowspan="2" width="80">单位</td>
                    <td colspan="4">期初余额</td>
                    <td colspan="2">本期借方</td>
                    <td colspan="2">本期贷方</td>
                    <td colspan="2">本年累计借方</td>
                    <td colspan="2">本年累计贷方</td>
                    <td colspan="4">期末余额</td>
                  </tr>
                  <tr>
                    <td width="100">方向</td>
                    <td width="100">数量</td>
                    <td width="100">单价</td>
                    <td width="100">金额</td>
                    <td width="100">数量</td>
                    <td width="100">金额</td>
                    <td width="100">数量</td>
                    <td width="100">金额</td>
                    <td width="100">数量</td>
                    <td width="100">金额</td>
                    <td width="100">数量</td>
                    <td width="100">金额</td>
                    <td width="100">方向</td>
                    <td width="100">数量</td>
                    <td width="100">单价</td>
                    <td width="100">金额</td>
                  </tr>
                  </thead>
                </table>
                <div class="table-body">
                  <table class="cus-table table-content">
                    <tbody>
                    <tr v-for="{subject,summary} in datalist" :key="subject.id">
                      <td width="100">{{subject.code}}</td>
                      <td width="100">{{subject.name}}</td>
                      <td width="80" class="text-center">{{subject.unit}}</td>
                      <td width="100" class="text-center">{{summary[0].balanceDirection}}</td>
                      <td width="100" class="text-right">{{summary[0].num}}</td>
                      <td width="100" class="text-right">{{summary[0].price|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[0].balance|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[1].debitAmount ? summary[1].num:''}}</td>
                      <td width="100" class="text-right">{{summary[1].debitAmount|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[1].creditAmount ? summary[1].num:''}}</td>
                      <td width="100" class="text-right">{{summary[1].creditAmount|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[2].debitAmount ? summary[2].num:''}}</td>
                      <td width="100" class="text-right">{{summary[2].debitAmount|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[2].creditAmount ? summary[2].num:''}}</td>
                      <td width="100" class="text-right">{{summary[2].creditAmount|numFormat}}</td>
                      <td width="100" class="text-center">{{summary[1].balanceDirection}}</td>
                      <td width="100" class="text-right">{{summary[1].num}}</td>
                      <td width="100" class="text-right">{{summary[1].price|numFormat}}</td>
                      <td width="100" class="text-right">{{summary[1].balance|numFormat}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>-->
    </div>
  </app-content>
</template>

<script>
import * as XLSX from "xlsx-js-style";

export default {
  name: 'GeneralLedger',
  filters: {
    numFormat(val) {
      if (val === null || val === undefined || val === '') return '';
      const n = Number(val);
      return isNaN(n) ? '' : n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  },
  data() {
    return {
      loading: false,
      accountDate: null,
      showNumPrice: false,
      numPriceDisabled: true,
      datalist: [],
      subjectList: [],
      startDate: null,
      endDate: null,
      formattedStartDate: null,
      formattedEndDate: null,
      subject: null,
      subjectId: null,
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'subjectCodeName',
        dataMode: 'list',
        datas: []
      },
    };
  },
  watch: {
    subject() {
      if (!this.subject) return;
      if (this.subject.unit) {
        this.numPriceDisabled = false;
        this.showNumPrice = true;
      } else {
        this.showNumPrice = false;
      }
      this.loadList();
    },
  },
  created() {
    this.loadSubject();
  },
  methods: {
    formatDateToFirstDay(monthStr) {
      const [year, month] = monthStr.split('-').map(Number);
      return `${year}-${String(month).padStart(2, '0')}-01`;
    },

    handleDateChange({ startMonth, endMonth }) {
      if (startMonth) {
        this.formattedStartDate = this.formatDateToFirstDay(startMonth);
        const [year, month] = startMonth.split('-').map(Number);
        this.startDate = new Date(year, month - 1, 1);
      }
      if (endMonth) {
        this.formattedEndDate = this.formatDateToFirstDay(endMonth);
        const [year, month] = endMonth.split('-').map(Number);
        this.endDate = new Date(year, month - 1, 1);
      }
    },

    handleConfirm(params) {
      this.formattedStartDate = this.formatDateToFirstDay(params.startMonth);
      this.formattedEndDate = this.formatDateToFirstDay(params.endMonth);

      if (params.subject) {
        this.subject = params.subject;
        this.subjectId = params.subject.id;
      } else {
        this.subject = null;
        this.subjectId = null;
      }
      this.loadList();
    },

    loadList() {
      this.loading = true;
      this.$api.accountbook.loadGeneralLedgerByDate({
        startDate: this.formattedStartDate,
        endDate: this.formattedEndDate,
        subjectId: this.subjectId,
        showNumPrice: this.showNumPrice,
      }).then(({ data }) => {
        this.datalist = data;
      }).catch(() => {
      }).finally(() => {
        this.loading = false;
      });
    },

    async loadSubject() {
      this.datalist = [];
      try {
        const { data } = await this.$api.accountbook.loadSubject({ accountDate: this.accountDate });
        const formattedData = data.map(subject => ({
          id: subject.id,
          subjectCode: subject.code,
          subjectName: subject.name,
          subjectCodeName: subject.code + " " + subject.name,
          subjectFullName: subject.subjectFullName || subject.name,
          ...subject
        }));
        this.subjectList = formattedData;
        this.$set(this.param, "datas", formattedData);
        if (formattedData.length) {
          this.subjectId = formattedData[0].id;
          this.subject = formattedData[0];
        }
      } catch (error) {
        console.error('加载科目失败:', error);
      }
    },

    toggleSummary(item) {
      this.$set(item, '_expand', !item._expand);
    },

    // ======= 纯前端导出，和明细账保持同一套写法 =======
    exportExcel() {
      if (!this.datalist || this.datalist.length === 0) {
        this.$Message.warning("暂无总账数据，无法导出");
        return;
      }
      const title = `总账`;
      const sheetData = [];
      sheetData.push([title]);
      sheetData.push([]);

      // 普通总账（当前启用）
      if (!this.showNumPrice) {
        sheetData.push(["科目编码", "科目名称", "期间", "摘要", "借方金额", "贷方金额", "方向", "余额"]);

        this.datalist.forEach(groupItem => {
          // 分组标题行（合并整行，和页面显示一致）
          sheetData.push([groupItem.name, "", "", "", "", "", "", ""]);
          // 明细行
          if (groupItem.subjectSummary && groupItem.subjectSummary.length) {
            groupItem.subjectSummary.forEach(s => {
              sheetData.push([
                s.code || "",
                s.subjectFullName || "",
                s.voucherDate || "",
                s.summary || "",
                this.$options.filters.numFormat(s.debitAmount),
                this.$options.filters.numFormat(s.creditAmount),
                s.balanceDirection || "",
                this.$options.filters.numFormat(s.balance)
              ]);
            });
          }
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        // 标题合并单元格
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];
        ws["!cols"] = [
          { wch: 12 },
          { wch: 22 },
          { wch: 12 },
          { wch: 22 },
          { wch: 14 },
          { wch: 14 },
          { wch: 8 },
          { wch: 14 }
        ];
        XLSX.utils.book_append_sheet(wb, ws, "总账");
        XLSX.writeFile(wb, `总账_${this.formattedStartDate}_${this.formattedEndDate}.xlsx`);
      } else {
        // 数量金额总账（你注释的表格，后续启用再完善）
        this.$Message.info("数量金额式导出逻辑待补充，暂时仅支持普通总账导出");
        return;
      }
      this.$Message.success("导出完成");
    }
  }
};
</script>

<style scoped lang="less">
.table-container {
  width: 100%;
  box-sizing: border-box;

  .table-wrap {
    position: relative;
    max-height: 650px;
    height: 650px;
    overflow: hidden;
    border: 1px solid #eee;
  }

  .table-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 20;
    border-collapse: collapse;
    box-sizing: border-box;
  }

  .table-body {
    width: 100%;
    height: 100%;
    padding-top: 35px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .table-content {
    width: 100%;
    border-collapse: collapse;
    box-sizing: border-box;
  }
}

.summary {
  td {
    padding: 0 8px;
    border: 1px solid #eee;
    font-size: 12px;
    height: 32px;
    box-sizing: border-box;
  }

  .summary-row:nth-child(even) {
    background-color: #f8fbf8;
  }

  .summary-row:hover {
    background-color: #dff7df;
  }

  .header {
    td {
      text-align: center;
      font-weight: bold;
      height: 35px;
    }
  }

  .bg-gray3-color {
    td {
      border: 1px solid #eee;
      height: 32px;
    }
  }
}

.cus-table {
  td {
    padding: 0 8px;
    border: 1px solid #eee;
    font-size: 12px;
    height: 32px;
    box-sizing: border-box;
  }

  .header {
    td {
      text-align: center;
      font-weight: bold;
      height: 35px;
      background: #f5f5f5;
    }
  }
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.padding {
  padding: 10px;
}
.text-hover {
  cursor: pointer;
}
</style>